import $ from "jquery";
import { gsap } from "gsap";
import slPars from "./slparams.json"; //importa el JSON para crear los Sliders requeridos
// 
//   @author Sergio Gabriel Navarro Márquez
//   eMovilidad, Soluciones en Tecnología
//  
//   slPars = {
//              "ids": "sliderppal",
//              "numSlides": 6,
//              "waitSlides": [8000, 8000, 8000, 8000, 8000, 8000, 8000],
//              "timer": null
//            }

var globs = {};

export function aquiToy(par) {
    console.log(par, slPars);
}
export function creaSlider() {
    //Esta función crea el HTML de los Sliders
    //usa el id de los parámetros para generar todo lo demás.
    //Genera objeto con parámetros del Slider
    //Usa el nombre del Slider para crear el identificador de elementos únicos del Slider
    //  - Slider Id
    //  - Slider Indx Id
    var i = 0;
    var sliderContainerId = "#" + slPars.ids;
    var ulSliderHtml = "<ul id='ul" + slPars.ids + "' class='snm-slideshow'><!--Inicia Slider rhplus--></ul>";
    var fixedIndexSreenHtml = "<h1 class='sliderfixed'>Texto del Fixed Caption</h1><div id='indx" + slPars.ids + "' class='indxslider'></div><div class='screenslider'></div>";
    
    // Crea el elemento ul y los elementos fixed caption, index y screen del Slider
    $(ulSliderHtml + fixedIndexSreenHtml).appendTo(sliderContainerId);
    
    //Vars de id's y clases del slider
    var ulSliderId = "#ul" + slPars.ids;
    var sliderIndexId = "#indx" + slPars.ids;

    
    var child = "";
    //**************************************************
    //
    //  Crea HTML de los slides
    //
    //**************************************************
    for(i = 1; i <= slPars.numSlides ; i++) {
        //**************************************************
        //
        //  Crea las "láminas" del slide
        //  <li>
        //      <span id="slideimg1"  class="lazy">Image</span>
        //      <div  id="slidecapt1" class="slidecapt"></div>
        //  </li>
        //  
        //**************************************************
        //<div class='slidepointerwrap'></div>
        $(ulSliderId).append('<li><span id="' + slPars.ids + 'img' + i.toString().trim() +'" class="lazy">Image' + i.toString().trim() +'</span><div id="' + slPars.ids + 'capt' + i.toString().trim() +'" class="slidecapt"></div></li>');
        //crea un punto index por cada slide
        $("<div id='" + "indxpoint" + i + "' class='slidepointerwrap'></div>").appendTo(sliderIndexId);
        //asigna un dato indexNumber a cada elemento index
        child = sliderIndexId + ' div:nth-child(' + i + ')';
        $(child).data("_slidenum", i);
        //Incluye Textos de captions
        $("#" + slPars.ids + "capt" + i).append(slPars.captSlides[i-1]);
    }
}

export function tweenSlider(slideNum) {
        //Ojo, esta función se llama de diferentes funciones y eventos
        //1.- Llamada inicial de tweenslider(1) desde document ready (init Slider)
        //    un argumento (slide(n))
        //
        //2.- Como callback onClick de los puntos .sliderpointerwrap
        //    un solo argumento que es el evento pasado al callback 
        //    (slide(n) y timer) se toman del objeto del evento.
        //    En este caso, el timer se obtiene como e.data
        //
        //3.- Como callback en setTimeout que se llama al final de tweenslider (next slide)
        //    dos argumentos (slide(n) y timer)
        //
        //4.- Explícitamente desde watchVisible(timer) cuando la página se hace visible o invisible
        //    i.e. cuando el usuario cambia de pestaña o minimiza la ventana o así.
        //    dos argumentos (slide(n) y timer)
        //
        //Esta función se llama desde .on("click") de los puntos .sliderpointerwrap (un solo argumento)
        //o de manera específica tweenSlider(n) recibiendo dos argumentos. 
        clearTimeout(slPars.timer);
        console.log("En TweenSlider slidenum: " + typeof slideNum);

        //**************************************************
        //  slideNum es el Nº de la slide a desplegar o un objeto event
        //  En cuyo caso this es el elemento indx al cual se le asignó
        //  el número de slide en creaSlide()
        //**************************************************
        if(isNaN(slideNum)) {
            // Se hizo click en un index circle
            var esteSlideNum = $(this).data("_slidenum");
        } else {
            var esteSlideNum = slideNum;
        }
        
        var nextSlide = esteSlideNum == slPars.numSlides ? 1 : esteSlideNum + 1;

        //Defino los jquery selectors de los siguientes elementos
        var estePunto = "#indxpoint" + esteSlideNum;                            //#indxpoint(i)
        var esteSlide = "#" + slPars.ids + "img" + esteSlideNum;                //#sliderppalimg(i)
        var esteChoro = "#" + slPars.ids + "capt" + esteSlideNum;               //#sliderppalcapt(i)
        var todosLosPuntos = "#indx" + slPars.ids + " .slidepointerwrap";       //#indxsliderppal .slidepointerwrap
        var todosLosSlides = "#ul" + slPars.ids + " span";                      //#ulsliderppal span
        var todosLosChoros = "#ul" + slPars.ids + " .slidecapt";                //#ulsliderppal .slidecapt
        
        gsap.killTweensOf(todosLosChoros);
        gsap.killTweensOf(todosLosSlides);
        
        var tweenDebug={};
        // tweenDebug.slidenumber = esteSlideNum;
        // tweenDebug.nextSlide = nextSlide;
        // tweenDebug.estePunto = estePunto; 
        // tweenDebug.esteSlide = esteSlide;
        // tweenDebug.esteChoro = esteChoro;
        // tweenDebug.todosLosPuntos = todosLosPuntos;
        // tweenDebug.todosLosSlides = todosLosSlides;
        // tweenDebug.todosLosChoros = todosLosChoros;
        // console.log("TweenDebug: ", tweenDebug);
        
        //Activa el choro en turno y la imagen en turno y desactiva los demás
        //Solo cambia su z-index y su opacidad
        // $(todosLosSlides + ", " + todosLosChoros).removeClass("active");
        // $(esteSlide + ", " + esteChoro).addClass("active");

        //gsap.set(todosLosSlides, { opacity:0 ,zIndex:125, scale:1});
        gsap.set(todosLosChoros, { opacity:0 ,zIndex:127, scale:1});
        gsap.set(esteSlide, { zIndex:130, opacity:1, scale:1});
        gsap.set(esteChoro, { zIndex:132, opacity:1, scale:1});

        //Cambia color del punto seleccionado y pone en blanco los demás
        gsap.set(todosLosPuntos, { backgroundColor: "transparent" });
        gsap.set(estePunto, { backgroundColor: "rgba(255, 255, 255, 0.8)" });

        //Presenta esteSlide
        gsap.to(todosLosSlides, { duration:1.5, opacity: 0, zIndex:125, xPercent: 0, overwrite:true});
        gsap.from(esteSlide, { duration:1.5, opacity: 0, zIndex:125, xPercent: 0, overwrite:true});
        gsap.from(esteChoro, { duration:1.25, opacity: 0, zIndex:127, delay: 0.25, overwrite:true});     

        //Programa el siguiente slider
        clearTimeout(slPars.timer);
        slPars.timer = setTimeout(tweenSlider, slPars.waitSlides[esteSlideNum - 1], nextSlide);
}//Termina funcion tweenSlider

//observo cuando la página no sea visible para detener los sliders
//Cuando la página se hace visible reinicia los sliders
//Cuando la página deja de ser visible, suspende los sliders 
export function watchVisible() {
    document.addEventListener("visibilitychange", function() {
              if (document.visibilityState == 'visible') {
                  console.log( "Doc visible", document.visibilityState );
                    tweenSlider(1);
              }
              if (document.visibilityState == 'hidden') {
                  console.log( "Doc invisible", document.visibilityState );
                    clearTimeout(slPars.timer);
                  }
            });
}
export function initSliderTimer() {
//**************************************************
//
//  Función que anima como radar los puntos index del slider
//  de acuerdo con el tiempo que tarda su presentación en pantalla
//  
//
//**************************************************
    var timerTimer = gsap.timeline({duration: 1, ease: "none"});

    timerTimer.eventCallback('onComplete', resetPolys).eventCallback('onInterrupt', resetPolys);
    
    var final = [   "200,-100  200,200   500,200",
                    "500, 200  200,200   200,500",
                    "200, 500  200,200  -100,200",
                    "-100,200  200,200   200, -100"
                ];

    function resetPolys() {
        timerTimer.progress(0);
    }

    $("#id_indxtimer polyline").each(function(i) {
        console.log("Polygon " + i + " :" + this.getAttribute("points"))
        timerTimer.to(this, {attr:{points: final[i]}, ease:"none"});
    });
    return timerTimer;
}